import { useLocation, useNavigate } from 'react-router-dom';
import { useBookpalNavigate } from 'component/common/custom/BookpalLink';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { convertStyle } from 'utils/Style';
import SubNav from "component/common/nav/SubNav";
import style from '../style/User.module.scss';
import { ApiCert, ApiCertLoading } from 'api/Cert';
import { appSetClose, isApp } from 'utils/AppUtil';
import { GetState, useMemberInfo } from 'utils/State';

function CertWarn(){

    const location = useLocation();
    const navigate = useBookpalNavigate();
    // const getState = GetState();
    const memberInfo = useMemberInfo();

    const isAdult = memberInfo?.is_adult;
    const isCert = memberInfo?.is_cert;

    const isLogin = memberInfo?.is_login;

    const [show, setShow] = useState(false);

    // const location = useLocation();
    const returnPath = location.state?.return_path;

    const certLoadingSubmit = ApiCert({
        returnPath:(returnPath ?? "/")
    });
    // console.log(memberInfo);



    return (
        <>
            <SubNav 
                name="" 
                usePc={false} 
                useMobile={true} 
                setTop={'0px'} 
                useBtnPrev={true} 
                onPrev={()=>{
                    if(isApp()){
                        appSetClose();
                        // return;
                    }
                    navigate(-1);
                }}
                // useBtnClose={true}
                // onClose={()=>{}}
            />
            {/* <!-- container --> */}
            <div id="container" className={convertStyle(style,"container s_wrap wrapper")} style={{marginTop:"0px"}}>
                <section className={convertStyle(style,"adultVerify")}>
                    <div
                    className={convertStyle(style,"area_box color-bg-01 radius-lg color-border-01 border-soild border-line")}
                    >
                        <div className={convertStyle(style,"logo_title")}>
                            <p className={convertStyle(style,"logo")}></p>
                        </div>
                        <div className={convertStyle(style,"text_box")}>
                            <p className={convertStyle(style,"body-03-long color-txt-normal")}>
                            이 정보 내용은 청소년 유해 매체물로서<br />
                            정보통신망 이용촉진 및 정보보호 등에 관한<br />
                            법률 및 청소년 보호법의 규정에 의하여<br />
                            19세 미만의 청소년은 이용할 수 없습니다.
                            </p>
                            <p className={convertStyle(style,"button_box")}>
                            {!(isLogin && isCert && !isAdult) ? 
                            <button
                                type="button"
                                className={convertStyle(style,"radius-sm btn-04 txt btn_01 large label_on filled button")}
                                onClick={()=>{
                                    certLoadingSubmit();
                                }}
                            >
                                휴대폰 본인인증하기
                            </button>
                            :null}
                            <button
                                type="button"
                                className={convertStyle(style,"radius-sm btn-04 txt btn_01 large label_on outlined button")}
                                onClick={()=>{
                                    if(isApp()){
                                        appSetClose();
                                        // return;
                                    }
                                    navigate(-1);
                                }}
                            >
                                이전으로 돌아가기
                            </button>
                            </p>
                        </div>
                        <div className={convertStyle(style,"text_box")}>
                            <p className={convertStyle(style,"body-02-long color-txt-03")}>
                            청소년보호법 제 16조 및 여성가족부 청소년 보호법<br />
                            관계 법령에 따라 연 1회 본인인증이 필요합니다.
                            </p>
                        </div>
                        {!(isLogin && isCert && !isAdult) ? 
                        <ul className={convertStyle(style,"toggle_list")}>
                            <li className={convertStyle(style,"border-line border-soild radius-sm color-border-01")}>
                            
                            <button 
                                type="button" 
                                className={convertStyle(style,"button large color-bg-01 label_on " + (show ? "click":""))}
                                onClick={()=>{
                                    setShow(!show);
                                }}
                                >
                                <span className={convertStyle(style,"color-txt-02 title-01-m-long")}
                                >해외 거주자 본인 인증 방법</span
                                >
                            </button>
                            
                            <div
                                className={convertStyle(style,"txt_box color-txt-03 body-02-long border-soild border-top-line color-bg-02 color-border-01")}
                                style={{display:(show?"block":"none")}}
                            >
                                본인 인증이 가능한 생년월일이 포함된 신분증을 북팔 아이디와 함께
                                메일(bookpal@bookpal.co.kr)로 보내주시면 인증 및 보상 지급
                                처리해드리도록 하겠습니다.<br /><br />※인증 완료 후 해당 정보는
                                즉시 파기됩니다.
                            </div>
                            </li>
                        </ul>
                        :null}
                    </div>
                </section>
            </div>
            {/* <!-- container --> */}
        </>
    );
}



export default CertWarn;